import { render, staticRenderFns } from "./ReplaceScreen.vue?vue&type=template&id=22c66072&"
import script from "./ReplaceScreen.vue?vue&type=script&lang=js&"
export * from "./ReplaceScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports